import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.css']
})
export class SearchbarComponent implements OnInit {
  queryKeyword: any;
  private sub: any;
  constructor(
    private readonly router: Router,
    private readonly routerLinkActive: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.routerLinkActive.queryParamMap.subscribe(
      (paramMap: ParamMap) => {
        this.queryKeyword = paramMap.get("keyword");
      }
    );
  }

  searchKeyword(queryKeyword:any) {
    const keyword = queryKeyword;
    if(keyword){
      this.router.navigate(['search'], {queryParams : {'keyword' : keyword}});
    }else{
      console.log("Please enter search keywords")
    }

  }

  keyDownFunction(event: any){
    if (event && event.keyCode === 13) {
      const keyword = this.queryKeyword;
      if (!keyword) {
        console.log("Please enter search keywords")
      } else {
        this.searchKeyword(this.queryKeyword);
      }
    }
  }

}